// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  stats: {
    root: path(ROOTS_DASHBOARD, '/stats'),
    global: path(ROOTS_DASHBOARD, '/stats/global'),
    regions: path(ROOTS_DASHBOARD, '/stats/regions'),
  },
  factory: {
    root: path(ROOTS_DASHBOARD, '/factory'),
    list: path(ROOTS_DASHBOARD, '/factory/list'),
    keys: path(ROOTS_DASHBOARD, '/factory/keys'),
  },
  tenants: {
    root: path(ROOTS_DASHBOARD, '/tenants'),
    list: path(ROOTS_DASHBOARD, '/tenants/list'),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/tenants/${id}`),
  },
  firmware: {
    root: path(ROOTS_DASHBOARD, '/firmware'),
    releases: path(ROOTS_DASHBOARD, '/firmware/releases'),
    targets: path(ROOTS_DASHBOARD, '/firmware/targets'),
    keys: path(ROOTS_DASHBOARD, '/firmware/keys'),
  },
};
